import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { Subscricao } from "src/app/model/subscricao.model";
import Utils from "src/app/shared/fgi-utils";


@Component({
    selector: 'app-subscricao-cotas-listagem',
    templateUrl: './subscricao-cotas-listagem.component.html',
    styleUrls: ['./subscricao-cotas-listagem.component.scss'],
    standalone: false
})
export class SubscricaoCotasListagemComponent {


  @Input() subscricoes: Subscricao[];
  @Input() msgSemResultado: boolean = false;
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Input() podeCadastrarSubscricao: boolean = true;
  @Input() dataHoraResultado: string;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public exportarSubscricoes: EventEmitter<any> = new EventEmitter<any>();

  private nomesAgentesFinanceiro:AgenteFinanceiro[] = [];
  public opcoesPaginacao: number[] = [10, 15, 20];
  public atributosOrdenacao: EntityOrderedRequestParameters;
  public rowHovered: number | null = null;

  constructor(
    private activatedRoute: ActivatedRoute){
    this.nomesAgentesFinanceiro = this.activatedRoute.snapshot.data['agentes'];
  }

  ngOnInit() {
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == 'valor') {
      funcao = parseFloat;
    }
    this.subscricoes = this.subscricoes.sort((a, b) => {
      if (ord.sentido == "asc") {
          return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
      else {
          return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if(typeof obj === 'undefined') {
      return false;
    }

    var _index = prop.indexOf('.')
    if(_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  btnExportarSubscricoes() {
    this.exportarSubscricoes.emit(null);
  }

  hover(index: number) {
    this.rowHovered = index;
  }

  hoverClean() {
    this.rowHovered = null;
  }
}
